import { FieldType } from '@wix/wix-data-schema-types'
import { GOOGLEMAP_ROLE } from '@wix/wix-data-client-common-standalone'
import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

const { text, email, url, stringArray, address } = FieldType

export default (): DataBindingComponentModel => ({
  isConnectGfppEnabled: true,
  supportsDefaultSelectedDataset: true,
  panel: {
    height: 550,
    title: 'Connect_Panel_Title_Google_Maps',
    helpId: '3af0fa61-098e-4b94-9abb-2312a7cf16a2',
  },
  sections: [
    {
      role: GOOGLEMAP_ROLE,
      bindings: [
        {
          title: 'Connect_Panel_Connect_Google_Maps_Location_Address_Label',
          prop: 'address',
          supportedFieldTypes: [address],
          defaultFieldType: address,
          supportsReferenceFields: true,
        },
        {
          title: 'Connect_Panel_Connect_Google_Maps_Location_Title_Label',
          prop: 'title',
          supportedFieldTypes: [text, email, address, stringArray],
          defaultFieldType: text,
          supportsReferenceFields: true,
          requiresPrimaryConnection: true,
        },
        {
          title: 'Connect_Panel_Connect_Google_Maps_Location_Description_Label',
          prop: 'description',
          supportedFieldTypes: [text, email, address, stringArray],
          defaultFieldType: text,
          supportsReferenceFields: true,
        },
        {
          title: 'Connect_Panel_Connect_Google_Maps_Location_Link_Label',
          prop: 'link',
          supportedFieldTypes: [url],
          defaultFieldType: url,
          supportsReferenceFields: true,
        },
        {
          title: 'Connect_Panel_Connect_Google_Maps_Link_Text_Label',
          prop: 'linkTitle',
          supportedFieldTypes: [text, email, address, stringArray],
          defaultFieldType: text,
          supportsReferenceFields: true,
        },
        {
          title: 'Connect_Panel_Connect_Google_Maps_Pin_Label',
          prop: 'icon',
          supportedFieldTypes: [url],
          defaultFieldType: url,
          supportsReferenceFields: true,
        },
      ],
      manifest: {
        gfpp: {
          desktop: {
            mainAction1: {
              actionId: 'googlemap_live_preview_gfpp_desktop_main_action',
              label: 'GoogleMap_Live_Preview_GFPP_Desktop_Main_Action',
            },
          },
        },
      },
      manageContentPanel: {
        description: 'Manage_Content_Panel_V2_Content',
      },
    },
  ],
  compactErrorPanel: true,
})
